/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copper(II) sulfate pentahydrate CuSO4·5H2O = 249.68 g/mol.`)
};

const es_mw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sulfato de cobre(II) pentahidratado CuSO4·5H2O = 249.68 g/mol.`)
};

const de_mw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kupfer(II)-sulfat-Pentahydrat CuSO4·5H2O = 249,68 g/mol.`)
};

const nl_mw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koper(II)sulfaat pentahydraat CuSO4·5H2O = 249,68 g/mol.`)
};

const fr_mw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sulfate de cuivre(II) pentahydraté CuSO4·5H2O = 249,68 g/mol.`)
};

const it_mw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solfato di rame(II) pentaidrato CuSO4·5H2O = 249,68 g/mol.`)
};

const pt_br2_mw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sulfato de cobre(II) pentaidratado CuSO4·5H2O = 249,68 g/mol.`)
};

const pt_mw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sulfato de cobre(II) pentahidratado CuSO4·5H2O = 249,68 g/mol.`)
};

const ja_mw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`硫酸銅(II)五水和物 CuSO4·5H2O = 249.68 g/mol。`)
};

const zh_mw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`五水硫酸铜 CuSO4·5H2O = 249.68 g/mol。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mw_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mw_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mw_ex3", locale)
	if (locale === "en") return en_mw_ex3(inputs)
	if (locale === "es") return es_mw_ex3(inputs)
	if (locale === "de") return de_mw_ex3(inputs)
	if (locale === "nl") return nl_mw_ex3(inputs)
	if (locale === "fr") return fr_mw_ex3(inputs)
	if (locale === "it") return it_mw_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_mw_ex3(inputs)
	if (locale === "pt") return pt_mw_ex3(inputs)
	if (locale === "ja") return ja_mw_ex3(inputs)
	return zh_mw_ex3(inputs)
};